export default class templateSettings {
    constructor() {
        return {
            template: require('../../../../views/maileditor/template-settings.html'),
            replace: true,
            restrict: 'E',
            controller: AdvancedEditorSettingsCtrl,
            controllerAs: 'advanced'
        }
    }
};

class AdvancedEditorSettingsCtrl {
    constructor($scope) {
        this._scope = $scope;

        this.showOverlay = false;
        this.activated = false;
        this.linkColor = null;
        this.linksUnderlined = true;

        this._scope.$on('mailEditor:settingsOverlay:toggle', (event, show) => {
            this.showOverlay = show;
        });
    }

    close() {
        this._scope.$emit('mailEditor:settingsOverlay:toggle', false);
    }

    toggleActive() {
        this.activated = ! this.activated;
    }
    
    changeColor() {
        this._scope.$emit('mailEditor:settings:linkColorChanged', this.linkColor);
    }

    changeUnderlineSettings() {
        this._scope.$emit('mailEditor:settings:linkUnderlineChanged', this.linksUnderlined);
    }

    changeImageSettings() {
        this._scope.$emit('mailEditor:settings:imageSettingsChanges', this.blockImages);
    }
}
